export default __webpack_public_path__ + "static/media/header-logo.dda23c55.svg";